var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPaperclip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design---Button",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ny-Innkaupabeidni-(Filled)",
    transform: "translate(-89.000000, -1259.000000)",
    fill: "#939598",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-5",
    transform: "translate(89.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach",
    transform: "translate(0.000000, 576.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,13.8 C8,15.4 5.5,15.4 3.9,13.8 C2.3,12.2 2.2,9.8 3.8,8.3 L8.3,3.8 C9.3,2.8 10.9,2.8 11.8,3.8 C12.8,4.8 12.8,6.4 11.8,7.3 L8.3,10.9 C7.9,11.3 7.3,11.3 6.9,10.9 C6.5,10.5 6.5,9.9 6.9,9.5 L9.7,6.7 L8.2,5.3 L5.5,8 C4.3,9.2 4.3,11.1 5.5,12.2 C6.7,13.3 8.6,13.4 9.7,12.2 L13.3,8.6 C15.1,6.8 15.1,4 13.3,2.2 C11.5,0.4 8.7,0.4 6.9,2.2 L2.4,6.9 C0.1,9.2 0.2,12.9 2.5,15.2 C3.7,16.4 5.2,17 6.8,17 C8.4,17 9.9,16.4 11,15.2 L15.3,10.9 L13.9,9.5 L9.6,13.8 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.d4a325d99de5d66ceda932d5d6c3e080.svg";
export { ForwardRef as ReactComponent };